module.exports = __webpack_public_path__ + "static/media/my-family-add-under16.19683faa.png";